import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { Box, Metadata, useTranslations } from "@bsm/component";
import { useMemo } from "react";
import { title } from "process";

export const StudentEmmergencyContactContainer = () => {

    const { id } = useParams();
    const { data } = useStudentDetailsQuery(parseInt(id), true);

    const [ 
        EMERGENCY_CONTACT,
        FAMILY_NAME,
        FIRST_NAMES,
        PHONE_NUMBERS,
        EMAIL,
    ] = useTranslations(i18nKeys);

    const emmergencyContact = useMemo(() => {
        return data.emmergencyContact
    }, [data])

    return (
        <div className="overflow-hidden rounded-3xl shadow bg-white">
            <Box title={EMERGENCY_CONTACT} className="flex flex-col gap-3">
                <Metadata label={FAMILY_NAME} value={emmergencyContact?.familyName} />
                <Metadata label={FIRST_NAMES} value={emmergencyContact?.firstName} />
                <Metadata label={PHONE_NUMBERS} value={emmergencyContact?.phones} />
                <Metadata label={EMAIL} value={emmergencyContact?.email} />
            </Box>
        </div>
    );
}

const i18nKeys = [
    "std_emergency_contact",
    "std_family_name",
    "std_first_names",
    "std_phone_numbers",
    "std_email"  
];
